import { render, staticRenderFns } from "./MetricsEditor.vue?vue&type=template&id=00335f09"
import script from "./MetricsEditor.vue?vue&type=script&lang=js"
export * from "./MetricsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports